type CanonicalDesignIdSource = {
	id: string;
	submissionId: string | null;
};

// Mirrors the save path's precedence (see save-customer-blueprint.ts) -- the server treats submissionId as canonical once a design has one.
export const getCanonicalDesignId = (blueprint: CanonicalDesignIdSource): string => blueprint.submissionId ?? blueprint.id;
